import type { IconProps } from './index';
import type { ReactElement } from 'react';

import { useTheme } from 'styled-components';

import { Svg } from './styles';

const PhosphorSlidersVerticalIcon = ({ className, color, hoverColor }: IconProps): ReactElement => {
  const theme = useTheme();

  return (
    <Svg
      className={className}
      viewBox="0 0 16 16"
      $hoverColor={hoverColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill={color || theme.colors.content.primary}>
        <path d="M10.5 2.5v2.06a2 2 0 0 0 0 3.88v5.06a.5.5 0 0 0 1 0V8.44a2 2 0 0 0 0-3.88V2.5a.5.5 0 0 0-1 0Zm1.5 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-6.5 7v-1.06a2 2 0 0 0 0-3.88V2.5a.5.5 0 1 0-1 0v6.06a2 2 0 0 0 0 3.88v1.06a.5.5 0 0 0 1 0Zm-1.5-3a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z" />
      </g>
    </Svg>
  );
};

export default PhosphorSlidersVerticalIcon;
